<div class="row table-row" [formGroup]="form">
    <div class="col-md-2">
        <select (change)="changeType($event.target.value)" class="form-control">
            @for (type of context.optionTypes; track type) {
                <option
                    [value]="type"
                    [selected]="form.controls.type.value == type"
                >
                    {{ translateType(type) }}
                </option>
            }
        </select>
    </div>
    <div class="col-md-2">
        <input
            class="form-control"
            type="text"
            hznTestId="option-name"
            formControlName="name"
            maxlength="160"
        />
    </div>
    <div class="col-md-4">
        <textarea
            class="form-control"
            rows="2"
            hznTestId="option-description"
            formControlName="description"
            maxlength="400"
        ></textarea>
    </div>
    <div class="col-md-2">
        <app-amount-picker
            [isRequired]="true"
            hznTestId="option-price"
            name="pricePerSession"
            formControlName="pricePerSession"
        ></app-amount-picker>
    </div>
    <div class="col-md-2">
        <button
            class="btn btn-success btn-action pull-right"
            [disabled]="!isFormValid()"
            type="button"
            bcClick
            hznTestId="option-save"
            (clicked)="save()"
        >
            {{ "General.Save" | translate }}
        </button>
        <button
            class="btn btn-danger btn-action pull-right mr-1"
            type="button"
            bcClick
            (clicked)="cancel()"
        >
            {{ "General.Cancel" | translate }}
        </button>
    </div>
</div>
